import styled from 'styled-components';

const ConfirmEmailStyles = styled.div`
  margin: 2em;
`;

export default ConfirmEmailStyles;
